const AUTH_KEYS = ["token", "userId", "userRole", "me", "emp_roles", "lastActivityAt"];

const authStore = {
  clearAll() {
    AUTH_KEYS.forEach((key) => localStorage.removeItem(key));
    sessionStorage.clear();
    window.dispatchEvent(new Event("authSessionChanged"));
  },
};

export default authStore;
